import React, { createContext, useContext, useMemo, useState } from 'react';

const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      event: 'Event',
      contact: 'Contact Us',
      media: 'Media',
      imageGallery: 'Image Gallery',
      videoGallery: 'Video Gallery',
    },
    header: {
      participation: 'Participation',
      registration: 'Registration',
      danceParticipation: 'Dance Participation',
      sponsorship: 'Sponsorship',
      getStarted: 'Get Started',
      registerHere: 'Register Here',
      registerYourParticipation: 'Register your Participation',
    },
    labels: {
      fullName: 'Full Name',
      email: 'E-mail',
      phone: 'Phone Number',
      phone_short: 'Phone',
      gender: 'Gender',
      occupation: 'Occupation',
      danceType: 'Dance Type',
      individualPerformance: 'Individual Performance',
      groupPerformance: 'Group Performance',
      numberOfParticipants: 'Number of Participants',
      sendMessage: 'Send Message',
      address: 'Address',
      idType: 'ID Type',
      idNumber: 'ID Number',
      upload: 'Upload',
      selectGender: 'Select gender',
      male: 'Male',
      female: 'Female',
      other: 'Other',
    },
    pages: {
      event: 'Event',
      eventTitle: 'Konark Patha Utsav',
      eventP1: 'Konark Patha Utsav is a vibrant street festival celebrating dance, music, and cultural expression in the historic streets of Konark.',
      eventP2: 'With diverse performers showcasing various dance forms, the event unites community and tradition in a joyful, open-air setting.',
      eventP3: 'We invite everyone to experience the spirit of creativity and togetherness under the timeless gaze of the Sun Temple.',
      homeHeroH3: 'Welcome to Konark Pathaustav',
      homeHeroH1: 'Celebrate Life with Music, Dance, and Rich Cultural Tradition',
      homeHeroP: 'Konark Pathautsav is set to transform the streets into a vibrant hub of performances, flavors, artistry, and cultural experiences. Join us as we celebrate and uplift local traditions.',
      aboutTitle: 'About us',
      aboutH3: 'What is this Event?',
      aboutH2: "The Ultimate Street Festival for Dance and Joy",
      aboutBtn: 'More About Us',
      contactTitle: 'Contact us',
      contactH3: 'Contact us',
      contactH2: 'Reach Out, Ride On!',
      contactFormTitle: 'Get in touch with us',
      contactSend: 'Send Message',
      historyTitle: 'History',
      historyH3: 'Our History',
      historyH2: 'The Origins of Konark Patha Utsav',
      historyBtn: 'more contact us',
      similarFestivalTitle: 'Similar Festival',
      aboutP1: 'Konark Patha Utsav is a vibrant street festival that invites individuals and groups to perform freely on the designated festival streets. Participants are encouraged to showcase any dance form of their choice, celebrating diversity and bringing joy through captivating performances that entertain and unite the community. Much like renowned international carnivals, this festival draws millions who come together to embrace culture, joy, and a spirit of togetherness.',
      aboutList1: 'Ideal for every generation',
      aboutList2: 'Celebrating new ideas and cultural creativity',
      aboutList3: 'Organized with the warmth of unity and shared stories',
      approachH3: 'Our Approach',
      approachH2: "Celebrate Odisha's Timeless Culture",
      approachP: 'Konark Patha Utsav is a celebration that breathes life into the artistic and cultural heritage of Odisha. It is more than a festival; it is a journey that connects hearts, preserves legacies, and ignites community pride through shared joy and creativity.',
      missionTitle: 'Our Mission',
      missionP: 'We aim to promote dance, music, and cultural heritage while fostering inclusive community bonding and building meaningful global connections.',
      visionTitle: 'Our Vision',
      visionP: 'We look forward to make Konark Patha Utsav a major global cultural event that attracts massive participation, inspire future generations, and nurture an united community.',
      contactIntroP: "Whether you're planning your first visit or coming back for more thrills, our team is ready to assist you with all the details you need.",
      contactLabelPhone: 'Contact',
      contactLabelEmail: 'Email Us At:',
      contactLabelAddress: 'Address At:',
      historyIntroP: "The idea of Konark Patha Utsav was born from the vision of Ashok Nanda, who first imagined bringing this vibrant festival to life. On September 9, 2025, after heartfelt discussions and shared passion, the dream took root and was confirmed, setting the stage for a celebration that would unite community, culture, and creativity in Konark’s streets.",
      historyList1: 'Activities crafted for families, elders, and youth alike',
      historyList2: 'Honoring traditions while welcoming innovative expressions',
      historyList3: 'Coming together as one to celebrate joy, culture, and community',
      historyList4: 'Innovation That Elevates Every Visit',
      similarGlobalH3: ' Global Street Festivals',
      similarGlobalH2: 'More Such Street Festivals Around the World',
      similarQuote: 'In the melody of every street celebration lies the harmony of a community bound by love and tradition,',
      similarP1: 'Across the globe, vibrant street festivals light up cities and towns with the same spirit that fuels Konark Patha Utsav. These celebrations bring communities together in joyful harmony, reminding us that culture has no borders.',
      similarRioTitle: 'The Rio Festival, Brazil',
      similarRioP: "Rio Festival, held annually in Rio de Janeiro, Brazil, is the world’s largest and most famous carnival, with origins dating back to 1723. It evolved from Portuguese colonial festivities called Entrudo, where people engaged in playful street games and masquerades before Lent.",
      similarSongkranTitle: 'Songkran Festival, Thailand',
      similarSongkranP: 'Songkran Festival is a vibrant celebration held during Thailand’s traditional New Year, blending lively dance performances with the country’s most iconic water festival.',
    }
  },
  hi: {
    nav: {
      home: 'होम',
      about: 'हमारे बारे में',
      event: 'कार्यक्रम',
      contact: 'संपर्क करें',
      media: 'मीडिया',
      imageGallery: 'चित्र गैलरी',
      videoGallery: 'वीडियो गैलरी',
    },
    header: {
      participation: 'प्रतिभागिता',
      registration: 'पंजीकरण',
      danceParticipation: 'नृत्य प्रतिभागिता',
      sponsorship: 'प्रायोजन',
      getStarted: 'शुरू करें',
      registerHere: 'यहाँ पंजीकरण करें',
      registerYourParticipation: 'अपनी भागीदारी पंजीकृत करें',
    },
    labels: {
      fullName: 'पूरा नाम',
      email: 'ई-मेल',
      phone: 'फोन नंबर',
      phone_short: 'फोन',
      gender: 'लिंग',
      occupation: 'व्यवसाय',
      danceType: 'नृत्य प्रकार',
      individualPerformance: 'व्यक्तिगत प्रस्तुति',
      groupPerformance: 'समूह प्रस्तुति',
      numberOfParticipants: 'प्रतिभागियों की संख्या',
      sendMessage: 'संदेश भेजें',
      address: 'पता',
      idType: 'पहचान प्रकार',
      idNumber: 'पहचान नंबर',
      upload: 'अपलोड',
      selectGender: 'लिंग चुनें',
      male: 'पुरुष',
      female: 'महिला',
      other: 'अन्य',
    },
    pages: {
      event: 'कार्यक्रम',
      eventTitle: 'कोणार्क पथ उत्सव',
      eventP1: 'कोणार्क पथ उत्सव एक जीवंत सड़क महोत्सव है जो नृत्य, संगीत और सांस्कृतिक अभिव्यक्ति का उत्सव मनाता है।',
      eventP2: 'विभिन्न प्रदर्शनकारी विभिन्न नृत्य रूपों को प्रदर्शित करते हैं, यह कार्यक्रम समुदाय और परंपरा को एक साथ लाता है।',
      eventP3: 'हम सभी को सूर्य मंदिर की कालातीत छाया में रचनात्मकता और एकता की भावना का अनुभव करने के लिए आमंत्रित करते हैं।',
      homeHeroH3: 'कोणार्क पथ उत्सव में आपका स्वागत है',
      homeHeroH1: 'संगीत, नृत्य और समृद्ध सांस्कृतिक परंपरा के साथ जीवन का उत्सव',
      homeHeroP: 'कोणार्क पथ उत्सव सड़कों को प्रस्तुतियों, स्वादों, कला और सांस्कृतिक अनुभवों के जीवंत केंद्र में बदल देगा। हमारे साथ जुड़ें और स्थानीय परंपराओं का उत्सव मनाएं।',
      aboutTitle: 'हमारे बारे में',
      aboutH3: 'यह कार्यक्रम क्या है?',
      aboutH2: 'नृत्य और आनंद के लिए अंतिम स्ट्रीट फेस्टिवल',
      aboutBtn: 'और अधिक जानें',
      contactTitle: 'संपर्क करें',
      contactH3: 'संपर्क करें',
      contactH2: 'राह दिखाएं, साथ चलें!',
      contactFormTitle: 'हमसे संपर्क करें',
      contactSend: 'संदेश भेजें',
      historyTitle: 'इतिहास',
      historyH3: 'हमारा इतिहास',
      historyH2: 'कोणार्क पथ उत्सव की उत्पत्ति',
      historyBtn: 'हमसे संपर्क करें',
      similarFestivalTitle: 'समान उत्सव',
      aboutP1: 'कोणार्क पथ उत्सव एक जीवंत सड़क महोत्सव है, जहाँ लोग और समूह निर्धारित सड़कों पर स्वतंत्र रूप से प्रदर्शन कर सकते हैं। प्रतिभागियों को अपनी पसंद का कोई भी नृत्य रूप प्रस्तुत करने के लिए प्रोत्साहित किया जाता है, ताकि विविधता का उत्सव मनाया जा सके और समुदाय को एकजुट किया जा सके।',
      aboutList1: 'हर पीढ़ी के लिए उपयुक्त',
      aboutList2: 'नए विचारों और सांस्कृतिक रचनात्मकता का उत्सव',
      aboutList3: 'एकता और साझा कहानियों की गर्मजोशी से आयोजित',
      approachH3: 'हमारा दृष्टिकोण',
      approachH2: 'ओडिशा की कालजयी संस्कृति का उत्सव',
      approachP: 'कोणार्क पथ उत्सव ओडिशा की कलात्मक और सांस्कृतिक धरोहर को जीवन देता है। यह केवल एक उत्सव नहीं, बल्कि दिलों को जोड़ने और समुदाय में गर्व जगाने की यात्रा है।',
      missionTitle: 'हमारा मिशन',
      missionP: 'हम नृत्य, संगीत और सांस्कृतिक धरोहर को बढ़ावा देने के साथ-साथ समावेशी सामुदायिक एकता और वैश्विक संबंधों को प्रोत्साहित करना चाहते हैं।',
      visionTitle: 'हमारा विजन',
      visionP: 'हम कोणार्क पथ उत्सव को एक प्रमुख वैश्विक सांस्कृतिक कार्यक्रम बनाना चाहते हैं जो बड़े पैमाने पर भागीदारी आकर्षित करे और आने वाली पीढ़ियों को प्रेरित करे।',
      contactIntroP: 'चाहे आपकी पहली यात्रा हो या आप फिर लौट रहे हों, हमारी टीम आपकी सहायता के लिए तैयार है।',
      contactLabelPhone: 'संपर्क',
      contactLabelEmail: 'ई-मेल करें:',
      contactLabelAddress: 'पता:',
      historyIntroP: 'कोणार्क पथ उत्सव का विचार अशोक नंदा की दृष्टि से जन्मा। 9 सितंबर, 2025 को यह सपना एक वास्तविक पहल में बदला, जो समुदाय, संस्कृति और रचनात्मकता को एक साथ लाता है।',
      historyList1: 'परिवारों, बुजुर्गों और युवाओं के लिए गतिविधियाँ',
      historyList2: 'परंपराओं का सम्मान और नवाचार का स्वागत',
      historyList3: 'खुशी, संस्कृति और समुदाय का एक साथ उत्सव',
      historyList4: 'हर यात्रा को बेहतर बनाने वाला नवाचार',
      similarGlobalH3: 'वैश्विक स्ट्रीट फेस्टिवल',
      similarGlobalH2: 'दुनिया भर के ऐसे और भी उत्सव',
      similarQuote: 'हर सड़क उत्सव की धुन में प्रेम और परंपरा से बंधे समुदाय की एकता झलकती है।',
      similarP1: 'दुनिया भर में ऐसे स्ट्रीट फेस्टिवल होते हैं जो समुदायों को एकजुट करते हैं और संस्कृति की सीमाहीनता का संदेश देते हैं।',
      similarRioTitle: 'रियो फेस्टिवल, ब्राज़ील',
      similarRioP: 'रियो फेस्टिवल दुनिया का सबसे बड़ा और प्रसिद्ध कार्निवल है, जिसकी शुरुआत 1723 से मानी जाती है।',
      similarSongkranTitle: 'सोंगक्रान फेस्टिवल, थाईलैंड',
      similarSongkranP: 'सोंगक्रान थाई नववर्ष का जीवंत उत्सव है, जो जल उत्सव और नृत्य प्रस्तुतियों के लिए प्रसिद्ध है।',
    }
  }
  ,
  or: {
    nav: {
      home: 'ଘର',
      about: 'ଆମ ବିଷୟରେ',
      event: 'କାର୍ଯ୍ୟକ୍ରମ',
      contact: 'ଯୋଗାଯୋଗ',
      media: 'ମାଧ୍ୟମ',
      imageGallery: 'ଛବି ଗ୍ୟାଲେରୀ',
      videoGallery: 'ଭିଡିଓ ଗ୍ୟାଲେରୀ',
    },
    header: {
      participation: 'ଅଂଶଗ୍ରହଣ',
      registration: 'ପଞ୍ଜିକରଣ',
      danceParticipation: 'ନୃତ୍ୟ ଅଂଶଗ୍ରହଣ',
      sponsorship: 'ପ୍ରଯୋଜକତ୍ୱ',
      getStarted: 'ଆରମ୍ଭ କରନ୍ତୁ',
      registerHere: 'ଏଠାରେ ପଞ୍ଜିକରଣ କରନ୍ତୁ',
      registerYourParticipation: 'ଆପଣଙ୍କର ଅଂଶଗ୍ରହଣ ପଞ୍ଜିକରଣ କରନ୍ତୁ',
    },
    labels: {
      fullName: 'ପୂର୍ଣ୍ଣ ନାମ',
      email: 'ଇ-ମେଲ',
      phone: 'ଫୋନ୍',
      phone_short: 'ଫୋନ୍',
      gender: 'ଲିଙ୍ଗ',
      occupation: 'ବ୍ୟବସାୟ',
      danceType: 'ନୃତ୍ୟ ପ୍ରକାର',
      individualPerformance: 'ବ୍ୟକ୍ତିଗତ ପ୍ରଦର୍ଶନ',
      groupPerformance: 'ଦଳୀୟ ପ୍ରଦର୍ଶନ',
      numberOfParticipants: 'ଅଂଶଗ୍ରହୀଙ୍କ ସଂଖ୍ୟା',
      sendMessage: 'ସନ୍ଦେଶ ପଠାନ୍ତୁ',
      address: 'ଠିକଣା',
      idType: 'ପରିଚୟ ପ୍ରକାର',
      idNumber: 'ପରିଚୟ ସଂଖ୍ୟା',
      upload: 'ଅପଲୋଡ୍',
      selectGender: 'ଲିଙ୍ଗ ବାଛନ୍ତୁ',
      male: 'ପୁରୁଷ',
      female: 'ମହିଳା',
      other: 'ଅନ୍ୟ',
    },
    pages: {
      event: 'କାର୍ଯ୍ୟକ୍ରମ',
      eventTitle: 'କୋଣାର୍କ ପଥ ଉତ୍ସବ',
      eventP1: 'କୋଣାର୍କ ପଥ ଉତ୍ସବ ଏକ ସଜ୍ଜ୍ୱଳ ରାସ୍ତା ଉତ୍ସବ, ଯେଉଁଥିରେ ନୃତ୍ୟ, ସଙ୍ଗୀତ ଓ ସଂସ୍କୃତିକ ଅଭିବ୍ୟକ୍ତିକୁ ଉତ୍ସବ କରାଯାଏ।',
      eventP2: 'ବିଭିନ୍ନ ପ୍ରଦର୍ଶନକାରୀମାନେ ନାନାପ୍ରକାର ନୃତ୍ୟ ଶୈଳୀ ଦେଖାନ୍ତି, ଏହି କାର୍ଯ୍ୟକ୍ରମ ସମାଜ ଓ ପରମ୍ପରାକୁ ଏକତ୍ର କରେ।',
      eventP3: 'ସୂର୍ଯ୍ୟ ମନ୍ଦିରର ଅବିନଶ୍ୱ ଛାୟା ତଳେ ସୃଜନଶୀଳତା ଓ ଏକତାର ଆନନ୍ଦ ଅନୁଭବ କରିବାକୁ ଆମେ ସମସ୍ତଙ୍କୁ ଆମନ୍ତ୍ରଣ ଜଣାଉଛୁ।',
      homeHeroH3: 'କୋଣାର୍କ ପଥଉତ୍ସବରେ ସ୍ୱାଗତ',
      homeHeroH1: 'ସଙ୍ଗୀତ, ନୃତ୍ୟ ଓ ସମ୍ରୁଦ୍ଧ ସଂସ୍କୃତି ସହ ଜୀବନ ଉତ୍ସବ',
      homeHeroP: 'କୋଣାର୍କ ପଥଉତ୍ସବ ରାସ୍ତାଗୁଡ଼ିକୁ ପ୍ରଦର୍ଶନ, ସ୍ୱାଦ, କଳା ଓ ସଂସ୍କୃତିର ସଜ୍ଜ୍ୱଳ କେନ୍ଦ୍ରରେ ପରିଣତ କରିବ। ଆମ ସହ ଯୋଗ ଦିଅନ୍ତୁ ଏବଂ ସ୍ଥାନୀୟ ପରମ୍ପରାକୁ ଉଦ୍ଜାପନ କରନ୍ତୁ।',
      aboutTitle: 'ଆମ ବିଷୟରେ',
      aboutH3: 'ଏହି କାର୍ଯ୍ୟକ୍ରମ କ’ଣ?',
      aboutH2: 'ନୃତ୍ୟ ଓ ଆନନ୍ଦ ପାଇଁ ଶ୍ରେଷ୍ଠ ରାସ୍ତା ଉତ୍ସବ',
      aboutBtn: 'ବିସ୍ତାରିତ',
      contactTitle: 'ଯୋଗାଯୋଗ',
      contactH3: 'ଯୋଗାଯୋଗ',
      contactH2: 'ଯୋଗାଯୋଗ କରନ୍ତୁ, ଆଗକୁ ବଢ଼ନ୍ତୁ!',
      contactFormTitle: 'ଆମ ସହ ଯୋଗାଯୋଗ କରନ୍ତୁ',
      contactSend: 'ସନ୍ଦେଶ ପଠାନ୍ତୁ',
      historyTitle: 'ଇତିହାସ',
      historyH3: 'ଆମ ଇତିହାସ',
      historyH2: 'କୋଣାର୍କ ପଥ ଉତ୍ସବର ଉତ୍ସ',
      historyBtn: 'ଯୋଗାଯୋଗ କରନ୍ତୁ',
      similarFestivalTitle: 'ସମାନ ଉତ୍ସବ',
      aboutP1: 'କୋଣାର୍କ ପଥ ଉତ୍ସବ ଏକ ସଜ୍ଜ୍ୱଳ ଉତ୍ସବ, ଯେଉଁଠାରେ ବ୍ୟକ୍ତିଗତ ଓ ଦଳ ନିର୍ଦ୍ଧାରିତ ରାସ୍ତାରେ ସ୍ୱେଚ୍ଛାରେ ପ୍ରଦର୍ଶନ କରିପାରନ୍ତି। ସମସ୍ତଙ୍କୁ ନିଜ ପସନ୍ଦର ନୃତ୍ୟ ଦେଖାଇବାକୁ ଉତ୍ସାହିତ କରାଯାଏ।',
      aboutList1: 'ପ୍ରତ୍ୟେକ ପିଢ଼ି ପାଇଁ ଉପଯୁକ୍ତ',
      aboutList2: 'ନୂତନ ଧାରଣା ଓ ସାଂସ୍କୃତିକ ସୃଜନଶୀଳତାର ଉତ୍ସବ',
      aboutList3: 'ଏକତା ଓ ସାଧାରଣ କହାଣୀର ଉଷ୍ମତାରେ ଆୟୋଜିତ',
      approachH3: 'ଆମର ପଦ୍ଧତି',
      approachH2: 'ଓଡିଶାର ଅବିନଶ୍ୱ ସଂସ୍କୃତିର ଉତ୍ସବ',
      approachP: 'କୋଣାର୍କ ପଥ ଉତ୍ସବ ଓଡିଶାର କଳା ଓ ସଂସ୍କୃତିକ ଐତିହ୍ୟକୁ ଜୀବନ ଦିଏ।',
      missionTitle: 'ଆମର ଲକ୍ଷ୍ୟ',
      missionP: 'ନୃତ୍ୟ, ସଙ୍ଗୀତ ଓ ଐତିହ୍ୟକୁ ପ୍ରୋତ୍ସାହନ ଦେଇ ସମାଜିକ ଏକତାକୁ ଶକ୍ତିଶାଳୀ କରିବା।',
      visionTitle: 'ଆମର ଦୃଷ୍ଟିକୋଣ',
      visionP: 'କୋଣାର୍କ ପଥ ଉତ୍ସବକୁ ବିଶ୍ଵ ସ୍ତରୀୟ ସାଂସ୍କୃତିକ ଆୟୋଜନ କରିବା।',
      contactIntroP: 'ଆପଣଙ୍କ ପ୍ରଥମ ଯାତ୍ରା କିମ୍ବା ପୁଣିଥରେ ଆସୁଛନ୍ତି, ଆମର ଟିମ୍ ସେବାରେ ପ୍ରସ୍ତୁତ।',
      contactLabelPhone: 'ଯୋଗାଯୋଗ',
      contactLabelEmail: 'ଇ-ମେଲ କରନ୍ତୁ:',
      contactLabelAddress: 'ଠିକଣା:',
      historyIntroP: 'କୋଣାର୍କ ପଥ ଉତ୍ସବର ଧାରଣା ଅଶୋକ ନନ୍ଦଙ୍କ ଦୃଷ୍ଟିରୁ ଜନ୍ମଲା। ୯ ସେପ୍ଟେମ୍ବର ୨୦୨୫ରେ ଏହି ସ୍ୱପ୍ନ ଏକ ପ୍ରୟାସରେ ପରିଣତ ହେଲା।',
      historyList1: 'ପରିବାର, ବୃଦ୍ଧ ଓ ଯୁବମାନଙ୍କ ପାଇଁ କାର୍ଯ୍ୟକଳାପ',
      historyList2: 'ପରମ୍ପରାର ସମ୍ମାନ, ନବତାର ସ୍ଵାଗତ',
      historyList3: 'ଖୁଶି, ସଂସ୍କୃତି ଓ ସମାଜର ସମିଳିତ ଉତ୍ସବ',
      historyList4: 'ପ୍ରତ୍ୟେକ ଯାତ୍ରାକୁ ଉନ୍ନତ କରୁଥିବା ନବତା',
      similarGlobalH3: 'ବିଶ୍ଵ ରାସ୍ତା ଉତ୍ସବଗୁଡ଼ିକ',
      similarGlobalH2: 'ବିଶ୍ୱର ଅନ୍ୟାନ୍ୟ ସମାନ ଉତ୍ସବ',
      similarQuote: 'ପ୍ରତ୍ୟେକ ରାସ୍ତା ଉତ୍ସବର ସୁରରେ ପ୍ରେମ ଓ ପରମ୍ପରାରେ ବନ୍ଧା ଏକତା ରହିଛି।',
      similarP1: 'ବିଶ୍ଵର ବିଭିନ୍ନ ସ୍ଥାନରେ ଏପରି ଉତ୍ସବ ହେଉଛି ଯାହା ସମାଜକୁ ଏକତ୍ର କରେ।',
      similarRioTitle: 'ରିଓ ଉତ୍ସବ, ବ୍ରାଜିଲ୍',
      similarRioP: 'ରିଓ ଉତ୍ସବ ବିଶ୍ୱର ସବୁଠୁ ବଡ଼ କାର୍ଣ୍ଣିଭାଲ୍, ଯାହାର ମୂଳ 1723 ରୁ ଦେଖାଯାଏ।',
      similarSongkranTitle: 'ସୋଙ୍ଗକ୍ରାନ୍ ଉତ୍ସବ, ଥାଇଲ୍ୟାଣ୍ଡ',
      similarSongkranP: 'ସୋଙ୍ଗକ୍ରାନ୍ ଥାଇ ପାରମ୍ପରିକ ନବବର୍ଷ ଉତ୍ସବ, ଜଳ ଉତ୍ସବ ଓ ନୃତ୍ୟ ପାଇଁ ପ୍ରସିଦ୍ଧ।',
    }
  }
};

const I18nContext = createContext({ lang: 'en', setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState('en');
  const dict = translations[lang] || translations.en;
  const t = useMemo(() => (key) => {
    const parts = String(key).split('.');
    let cur = dict;
    for (const p of parts) {
      cur = cur && cur[p];
    }
    return cur || key;
  }, [dict]);
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}


